@if (printoutItems()) {
  <div class="component-printout-menu"
    >
    <!-- Show search only if more than 5 items -->
    @if (printoutItems().length > 5) {
      <option-list-search
        [placeholder]="'Search printouts'"
        (inputChanged)="printoutFilter=$event"
        (inputCleared)="printoutFilter=''"
      ></option-list-search>
    }
    <!-- Display the filtered printouts -->
    @for (item of printoutItems() | filterByValue: filterPrintouts : printoutFilter; track trackByPrintout($index, item)) {
      @if (!item.url) {
        <span style="color:white;font-size:1.1rem;padding: 0 6px">{{ item.name }}</span>
      }
      @if (item.url) {
        <div class="row center space-between">
          <span>{{ item.name }}</span>
          <div class="row start format-options">
            <a (click)="downloadPrintout(item.url, PrintoutFormat.PDF)" target="_blank" mat-menu-item matTooltip="Print as PDF"
              [matTooltipShowDelay]="TOOLTIP_SHOW_DELAY"><i
            class="fas fa-file-pdf"></i></a>
            @if (allowOtherFormats) {
              <a (click)="downloadPrintout(item.url_word, PrintoutFormat.DOCX)" target="_blank" mat-menu-item
                [matTooltip]="'Print as Word document' + (!item.additional_formats.includes('word')? ' (unavailable)':'')"
                [matTooltipShowDelay]="TOOLTIP_SHOW_DELAY"
                [disabled]="!item.additional_formats.includes('word')"><i
              class="fas fa-file-word"></i></a>
              <a (click)="downloadPrintout(item.url_excel, PrintoutFormat.XLSX)" target="_blank" mat-menu-item
                [matTooltip]="'Print as Excel document' + (!item.additional_formats.includes('excel')? ' (unavailable)':'')" [matTooltipShowDelay]="TOOLTIP_SHOW_DELAY"
                [disabled]="!item.additional_formats.includes('excel')"><i
              class="fas fa-file-excel"></i></a>
            }
          </div>
        </div>
      }
      @if (!item) {
        <div style="pointer-events: none; cursor: default; padding: 0 6px">
          <hr [className]="item.class" style="border: 0; height: 1px; background-color: #dbd3d2"/>
        </div>
      }
    }
  </div>
}
